import VModel from "@/vuetify_custom/v-modal_v1";
import { postRefundOfflineApplyBatchImportApi } from "./services";

export default {
  data() {
    return {
      visible: false,
      filePath: "",
    };
  },
  methods: {
    show() {
      this.visible = true;
      this.filePath = "";
    },
    close() {
      this.visible = false;
    },
    submit() {
      if (!this.filePath) {
        this.$Message.error("请选择文件");
        return;
      }

      const formData = new FormData();
      formData.append("data_file", this.filePath);
      console.log(formData);

        postRefundOfflineApplyBatchImportApi(formData).then((res) => {
        this.visible = false;
        this.$emit("success");
        this.$Message.success("导入成功");
      });
    },
      handleFileChange(event) {
          const file = event.target.files[0];
          // 处理文件逻辑
      }
  },
  render() {
    return (
      <VModel
        v-model={this.visible}
        persistent
        dynamic-height
        height-rate={0.7}
        title={"批量导入申请"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <div>
          <input type="file" v-model={this.filePath} />
        </div>
      </VModel>
    );
  },
};
